function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#757575",
  d: "M23.5 14a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2A1.5 1.5 0 0 1 2 .5h20A1.5 1.5 0 0 1 23.5 2v12z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A49",
  d: "M10 3.5h11.455M10 6h11.455M10 9h11.455M16.5 12.5h5M2.5 12.5H14"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#757575",
  d: "M5.5 6C6.881 6 8 7.343 8 9H3c0-1.657 1.119-3 2.5-3zm0-3a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 5.5 3z"
}));

var SvgRneListIcon = function SvgRneListIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRneListIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rne_list_icon.0ed87f32.svg";
export { ForwardRef as ReactComponent };